import i18n from '../strings/i18n';
import useCurrentLanguage from './use-current-language';
var useTranslation = function () {
    var currentLanguage = useCurrentLanguage();
    return i18n(currentLanguage);
};
export default useTranslation;
//# sourceMappingURL=use-translation.js.map